import { createStylesheet } from './createStylesheet';

export const appendStylesheet = (src: string): void => {
  window.requestAnimationFrame(() =>
    document.head.appendChild(createStylesheet(src)),
  );
};
